module.exports = __webpack_public_path__ + "static/media/403-forbidden.3a2c3283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/403-forbidden.jpg
// module id = 1442
// module chunks = 0